import React, { Component } from "react";
import { Alert, Card, Col, Input, Row, Space, Typography, message } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  FilePdfOutlined,
  MailOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { ButtonItem, ModalItem } from "../../../../Components/Items";
import solicitudCotizacionPdf from "../../../../Pdf/solicitudCotizacionPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text } = Typography;

const MAX_CORREOS = 5;

/**
 * Revision y envio de las solicitudes ya generadas: un PDF y un correo por proveedor.
 *
 * Las solicitudes ya existen en la base cuando se abre este modal (se crearon en
 * generarSolicitudes). Cerrar sin enviar es valido: quedan en estado "Solicitada" y el
 * usuario puede descargar los PDF y mandarlos por su cuenta.
 */
class ModalEnviarSolicitud extends Component {
  state = {
    correosPorSolicitud: {},
    enviando: false,
    modalPdf: false,
    solicitudPdf: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      const correosPorSolicitud = {};
      (this.props.solicitudes || []).forEach((valueSolicitud) => {
        const correos = (valueSolicitud.correosEnvio || []).map((valueCorreo) => ({
          correo: valueCorreo.correo || "",
        }));
        correosPorSolicitud[valueSolicitud.cotizacionId] =
          correos.length > 0 ? correos : [{ correo: "" }];
      });
      this.setState({ correosPorSolicitud, enviando: false });
    }
  }

  cambiarCorreo = (cotizacionId, indice, valor) => {
    this.setState((prevState) => {
      const correos = [...(prevState.correosPorSolicitud[cotizacionId] || [])];
      correos[indice] = { correo: valor };
      return {
        correosPorSolicitud: {
          ...prevState.correosPorSolicitud,
          [cotizacionId]: correos,
        },
      };
    });
  };

  agregarCorreo = (cotizacionId) => {
    this.setState((prevState) => {
      const correos = [...(prevState.correosPorSolicitud[cotizacionId] || [])];
      if (correos.length >= MAX_CORREOS) return null;
      correos.push({ correo: "" });
      return {
        correosPorSolicitud: {
          ...prevState.correosPorSolicitud,
          [cotizacionId]: correos,
        },
      };
    });
  };

  quitarCorreo = (cotizacionId, indice) => {
    this.setState((prevState) => {
      const correos = [...(prevState.correosPorSolicitud[cotizacionId] || [])];
      correos.splice(indice, 1);
      return {
        correosPorSolicitud: {
          ...prevState.correosPorSolicitud,
          [cotizacionId]: correos.length > 0 ? correos : [{ correo: "" }],
        },
      };
    });
  };

  construirPdf = (solicitud) =>
    solicitudCotizacionPdf({
      ...this.props.comun,
      data: { numero: solicitud.numero },
      proveedor: solicitud.proveedor,
    });

  verPdf = (solicitud) => {
    this.setState({ modalPdf: true, solicitudPdf: solicitud }, () => {
      pdfMake
        .createPdf(this.construirPdf(solicitud))
        .open({}, window.frames["solicitudEnvioPdf"]);
    });
  };

  descargarPdf = (solicitud) => {
    pdfMake
      .createPdf(this.construirPdf(solicitud))
      .download(`SolicitudCotizacion_${solicitud.numero}.pdf`);
  };

  enviar = async () => {
    const envios = (this.props.solicitudes || [])
      .map((valueSolicitud) => ({
        cotizacionId: valueSolicitud.cotizacionId,
        correosEnvio: (this.state.correosPorSolicitud[valueSolicitud.cotizacionId] || [])
          .filter((valueCorreo) => valueCorreo.correo && valueCorreo.correo.trim())
          .map((valueCorreo) => ({ correo: valueCorreo.correo.trim() })),
      }))
      .filter((valueEnvio) => valueEnvio.correosEnvio.length > 0);

    if (envios.length === 0) {
      message.info("Proporcione al menos un correo de envío");
      return;
    }

    this.setState({ enviando: true });
    try {
      const res = await axios.post(
        "cotizacionesRequisicion/enviarSolicitudMail",
        { empresaId: this.props.empresaId, envios },
        { headers: this.props.headersToken }
      );

      this.setState({ enviando: false });

      if (res.data.success !== 2) {
        message.error("Sucedió un error y no se pudieron enviar los correos");
        return;
      }

      const enviados = res.data.resultados.filter((valueResultado) => valueResultado.ok);
      if (enviados.length === 0) {
        message.error("No se pudo enviar ninguna solicitud");
        return;
      }
      if (enviados.length < res.data.resultados.length) {
        message.warning(
          `Se enviaron ${enviados.length} de ${res.data.resultados.length} solicitudes`
        );
      } else {
        message.success("Solicitudes enviadas");
      }
      this.props.onEnviado();
    } catch (err) {
      console.error(err);
      this.setState({ enviando: false });
      message.error("Sucedió un error y no se pudieron enviar los correos");
    }
  };

  render() {
    const { visible, onCancel, solicitudes } = this.props;
    const { correosPorSolicitud, enviando } = this.state;

    return (
      <ModalItem
        title="Enviar Solicitudes de Cotización"
        visible={visible}
        onCancel={onCancel}
        width={800}
        spinning={enviando}
        paddingTop
      >
        <div style={{ padding: "0 15px 15px 15px" }}>
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 15 }}
            message="Las solicitudes ya quedaron guardadas"
            description="Puedes mandarlas por correo desde aquí o cerrar y descargar cada PDF para enviarlo por tu cuenta."
          />

          {(solicitudes || []).map((valueSolicitud) => {
            const correos = correosPorSolicitud[valueSolicitud.cotizacionId] || [];
            return (
              <Card
                key={valueSolicitud.cotizacionId}
                size="small"
                style={{ marginBottom: 12 }}
                title={
                  <span>
                    <Text strong>{valueSolicitud.proveedor?.nombre}</Text>{" "}
                    <Text type="secondary">
                      (Solicitud {valueSolicitud.numero})
                    </Text>
                  </span>
                }
                extra={
                  <Space>
                    <ButtonItem
                      size="small"
                      icon={<FilePdfOutlined />}
                      onClick={() => this.verPdf(valueSolicitud)}
                    >
                      Ver PDF
                    </ButtonItem>
                    <ButtonItem
                      size="small"
                      icon={<DownloadOutlined />}
                      onClick={() => this.descargarPdf(valueSolicitud)}
                    >
                      Descargar
                    </ButtonItem>
                  </Space>
                }
              >
                {correos.map((valueCorreo, indice) => (
                  <Row key={indice} gutter={8} style={{ marginBottom: 6 }}>
                    <Col span={22}>
                      <Input
                        placeholder="Correo"
                        value={valueCorreo.correo}
                        onChange={(e) =>
                          this.cambiarCorreo(
                            valueSolicitud.cotizacionId,
                            indice,
                            e.target.value
                          )
                        }
                      />
                    </Col>
                    <Col span={2} style={{ textAlign: "center", paddingTop: 5 }}>
                      <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() =>
                          this.quitarCorreo(valueSolicitud.cotizacionId, indice)
                        }
                      />
                    </Col>
                  </Row>
                ))}
                {correos.length < MAX_CORREOS && (
                  <ButtonItem
                    type="link"
                    icon={<PlusOutlined />}
                    onClick={() => this.agregarCorreo(valueSolicitud.cotizacionId)}
                  >
                    Agregar correo
                  </ButtonItem>
                )}
              </Card>
            );
          })}

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 15 }}>
            <ButtonItem rojo onClick={onCancel}>
              Cerrar sin enviar
            </ButtonItem>
            <ButtonItem
              type="primary"
              icon={<MailOutlined />}
              loading={enviando}
              onClick={this.enviar}
            >
              Enviar correos
            </ButtonItem>
          </div>
        </div>

        <ModalItem
          title={`Solicitud ${this.state.solicitudPdf?.numero || ""}`}
          visible={this.state.modalPdf}
          onCancel={() => this.setState({ modalPdf: false, solicitudPdf: null })}
          paddingTop
        >
          <iframe
            title="Solicitud de Cotización"
            style={{ width: "100%", height: "100vh" }}
            id="solicitudEnvioPdf"
            name="solicitudEnvioPdf"
          />
        </ModalItem>
      </ModalItem>
    );
  }
}

export default ModalEnviarSolicitud;
